import {
  Component,
  DestroyRef,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  inject,
  ChangeDetectorRef,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MeetingRecord } from 'src/app/models/meeting-record.interface';
import { MeetingRecordSummaryGenerationStatus } from 'src/app/models/meeting-record-summary-generation-status.type';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { TinymceService } from 'src/app/services/tinymce.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

import { MatDialog } from '@angular/material/dialog';
import { AddUserDialogComponent } from 'src/app/components/main/employees/direction/users/add-user-dialog/add-user-dialog.component';
import { AddUserDialogData } from 'src/app/interfaces/add-user-dialog-data.interface';
import { RoleSlugEnum } from 'src/app/enums/role-slug.enum';
import { ClientRoleEnum } from 'src/app/enums/client-role.enum';
import { PasswordOptionEnum } from 'src/app/enums/password-option.enum';
import { MatDividerModule } from '@angular/material/divider';
import { UserService } from 'src/app/services';
import {
  catchError,
  concatMap,
  debounceTime,
  distinctUntilChanged,
  filter,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';
import { CompanyProduct } from 'src/app/models/company_product.model';
import { Role } from 'src/app/models/role.model';
import { JobVacancyCandidate, JobVacancyCandidatePhaseProgress } from 'src/app/models/job_candidate.model';
import { ExamInstanceEvaluation } from 'src/app/models/exam_instance_evaluation.model';
import { MatMenuModule } from '@angular/material/menu';
import { ExamInstanceEvaluationStatusEnumLabels } from 'src/app/enums/exam-instance-evaluation-status.enum';
import { SelectorDialogComponent, SelectorDialogDataRow } from '../selector-dialog/selector-dialog.component';
import { CheckboxSelectorDialogComponent } from '../checkbox-selector-dialog/checkbox-selector-dialog.component';
import { InputDialogComponent } from '../input-dialog/input-dialog.component';
import { User as UserModel } from 'src/app/models/user.model';
import { ExamInstance } from 'src/app/models/exam_instance.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PotentialClient } from 'src/app/models/potential-client.interface';
import { MediaRecording, MediaRecordingTranscriptionStatus } from 'src/app/models/media-recording.model';
import { MediaRecordingUploadFailurePhaseEnum } from 'src/app/enums/media-recording-upload-failure-phase.enum';
import { MediaRecordingUploadRetryKindEnum } from 'src/app/enums/media-recording-upload-retry-kind.enum';
import { MeetingRecordMediaRecordingPusherUpdate } from 'src/app/models/meeting-record-media-recording-pusher-update.model';
import { PusherService } from 'src/app/services/pusher.service';
import dayjs from 'dayjs';
import { ActiveRecordingState, RecordingPendingUploadMetadata, RecordingService } from 'src/app/services/recording.service';
import { MeetingRecordMediaRecordingsDialogComponent } from './meeting-record-media-recordings-dialog/meeting-record-media-recordings-dialog.component';
import { MeetingRecordActaTabComponent } from './meeting-record-acta-tab/meeting-record-acta-tab.component';
import { resolveMediaRecordingDiarizationInterventions } from './media-recording-diarization-page/media-recording-diarization-page.component';
import { MeetingRecordSummaryTabComponent } from './meeting-record-summary-tab/meeting-record-summary-tab.component';
import { MeetingRecordDiarizationTabComponent } from './meeting-record-diarization-tab/meeting-record-diarization-tab.component';
import { MeetingRecordPersonalNotesTabComponent } from './meeting-record-personal-notes-tab/meeting-record-personal-notes-tab.component';
import { MeetingRecordAttachmentsTabComponent } from './meeting-record-attachments-tab/meeting-record-attachments-tab.component';
import { MeetingRecordActaTabId } from 'src/app/models/meeting-record-acta-tab-id.type';
import { Attachment } from 'src/app/models/attachment.interface';
import { RecordingSetupDialogComponent, RecordingSetupDialogResult } from './recording-setup-dialog/recording-setup-dialog.component';
import { PlatformService } from 'src/app/services/platform.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { saveAs } from 'file-saver';
import { PendingChangesGuard } from 'src/app/guards/pending-changes.guard';
import { PendingChangesSaveStatusComponent } from 'src/app/components/main/shared/pending-changes-save-status/pending-changes-save-status.component';
import { MediaRecordingStatusLabelPipe } from 'src/app/pipes/media-recording-status-label.pipe';
import { MediaRecordingProcessingOnServerPipe } from 'src/app/pipes/media-recording-processing-on-server.pipe';
import { MediaRecordingServerProcessingLabelPipe } from 'src/app/pipes/media-recording-server-processing-label.pipe';
import { MediaRecordingTranscriptionInFlightPipe } from 'src/app/pipes/media-recording-transcription-in-flight.pipe';
import { MediaRecordingTranscriptionBannerLabelPipe } from 'src/app/pipes/media-recording-transcription-banner-label.pipe';
import { RecordingElapsedLabelPipe } from 'src/app/pipes/recording-elapsed-label.pipe';
import { createPendingChangesSaveStatus, PendingChangesSaveStatus } from 'src/app/utils/pending-changes-save-status';

@Component({
  selector: 'app-meeting-record',
  templateUrl: './meeting-record.component.html',
  styleUrls: ['./meeting-record.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSelectModule,
    MatOptionModule,
    MatDividerModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTooltipModule,
    NgxDropzoneModule,
    MediaRecordingStatusLabelPipe,
    MediaRecordingServerProcessingLabelPipe,
    MediaRecordingTranscriptionBannerLabelPipe,
    RecordingElapsedLabelPipe,
    MeetingRecordActaTabComponent,
    MeetingRecordSummaryTabComponent,
    MeetingRecordDiarizationTabComponent,
    MeetingRecordPersonalNotesTabComponent,
    MeetingRecordAttachmentsTabComponent,
    PendingChangesSaveStatusComponent,
  ],
})
export class MeetingRecordComponent implements OnInit {
  private api = inject(ApiService);
  protected fb = inject(FormBuilder);
  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);
  tinymce = inject(TinymceService);
  protected utils = inject(UtilsService);
  private dialog = inject(MatDialog);
  private userService = inject(UserService);
  private snack_bar = inject(MatSnackBar);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  @Input() meetingableType:
    | 'App\\Models\\User'
    | 'App\\Models\\CompanyProduct'
    | 'App\\Models\\PotentialClient'
    | 'App\\Models\\JobVacancyCandidatePhaseProgress';
  @Input() meetingableId: number;
  @Input() meetingRecordId: number;
  @Input() onBackRoute: string;
  @Input() onSaveRoute: string;
  @Input() jobVacancyCandidateId: number | null = null;

  meetingRecordFormGroup: FormGroup;
  tinyMceApiKey: string;

  users_searched: User[] = [];
  meetingable_label = '';
  candidate_user_id: number | null = null;
  interviewed_user: User | null = null;
  interviewed_user_label = '—';

  userInputValue = new FormControl('');
  user_create_typed_name = '';
  auto_active_create_user_option = false;
  readonly create_user_option_value = '__create_user__';
  protected readonly user_chip_separator_keys: number[] = [];
  private is_opening_add_user_dialog = false;
  personal_notes_control = new FormControl('', { nonNullable: true });

  protected readonly acta_tabs: { id: MeetingRecordActaTabId; label: string }[] = [
    { id: 'acta', label: 'Acta' },
    { id: 'ai_summary', label: 'Resumen IA' },
    { id: 'diarization', label: 'Diarización' },
    { id: 'personal_notes', label: 'Notas personales' },
    { id: 'attachments', label: 'Archivos' },
  ];

  protected active_acta_tab = signal<MeetingRecordActaTabId>('acta');

  protected diarization_seek_seconds = signal<number | null>(null);

  protected summary_generation_status = signal<MeetingRecordSummaryGenerationStatus | null>(null);

  protected ai_summary_html = signal<string | null>(null);

  protected attachments = signal<Attachment[]>([]);

  protected readonly attachments_count = computed(() => this.attachments().length);

  protected readonly attachment_max_file_size_bytes = 10 * 1024 * 1024;

  protected readonly attachment_accepted_types =
    '.pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.zip,.rar,.7z,.jpg,.jpeg,.png,.gif,.webp,.svg';

  protected can_manage_attachments = signal(false);

  protected is_uploading_attachments = signal(false);

  protected readonly pending_changes_save_status = createPendingChangesSaveStatus();

  protected readonly autosave_status = this.pending_changes_save_status.status;

  protected readonly last_saved_at = signal<Date | null>(null);

  protected readonly autosave_tooltip = computed(() => {
    const last_saved_at = this.last_saved_at();
    if (last_saved_at == null) {
      return 'Sin guardar todavía';
    }

    return `Último guardado: ${dayjs(last_saved_at).format('DD/MM/YYYY HH:mm')}`;
  });

  protected readonly show_manual_save_button = this.pending_changes_save_status.is_error;

  @ViewChild('userInputTrigger', { read: MatAutocompleteTrigger }) userInputTrigger: MatAutocompleteTrigger;
  @ViewChild('userChipInput') user_chip_input?: ElementRef<HTMLInputElement>;

  isSubmitting: boolean = false;
  is_importing_media_recording = false;
  candidate_phase_progress_options: JobVacancyCandidatePhaseProgress[] = [];
  exam_instance_evaluations: ExamInstanceEvaluation[] = [];
  private linked_exam_instance_evaluation: ExamInstanceEvaluation | null = null;
  private initial_acta_tab_resolved = false;
  private form_change_generation = 0;
  private is_persisting = false;

  tinyMceInit = {
    plugins:
      'anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist preview code fullscreen emoticons',
    toolbar:
      'undo redo spellcheckdialog | blocks fontfamily fontsize | codesample | bold italic underline strikethrough | forecolor backcolor | insertfile link image | align lineheight bullist numlist | indent outdent | removeformat | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
    automatic_uploads: true,
    statusbar: false,
    menubar: false,
    block_unsupported_drop: false,
    ui_mode: 'split' as const,
    height: '68vh',
    width: '100%',
    resize: true,
    codesample_languages: [
      { text: 'HTML/XML', value: 'c' },
      { text: 'JavaScript', value: 'javascript' },
      { text: 'CSS', value: 'css' },
      { text: 'PHP', value: 'php' },
      { text: 'Ruby', value: 'ruby' },
      { text: 'Python', value: 'python' },
      { text: 'Java', value: 'java' },
      { text: 'C', value: 'c' },
      { text: 'C#', value: 'csharp' },
      { text: 'C++', value: 'cpp' },
      { text: 'Bash', value: 'bash' },
      { text: 'SQL', value: 'sql' },
      { text: 'JSON', value: 'json' },
      { text: 'YAML', value: 'yaml' },
      { text: 'Markdown', value: 'markdown' },
      { text: 'Dockerfile', value: 'dockerfile' },
      { text: 'Git', value: 'git' },
      { text: 'Nginx', value: 'nginx' },
      { text: 'Apache', value: 'apache' },
      { text: 'Ini', value: 'ini' },
      { text: 'TypeScript', value: 'typescript' },
      { text: 'Dart', value: 'dart' },
    ],
  };

  is_create: boolean = true;
  protected back_route = '../..';

  protected media_recordings = signal<MediaRecording[]>([]);

  private meeting_record_pusher_unsubscribe: (() => void) | null = null;

  private recording_service = inject(RecordingService);
  private pusher = inject(PusherService);
  private platform = inject(PlatformService);
  private change_detector_ref = inject(ChangeDetectorRef);
  private destroy_ref = inject(DestroyRef);
  private pending_changes_guard = inject(PendingChangesGuard);
  private media_recording_processing_on_server_pipe = inject(MediaRecordingProcessingOnServerPipe);
  private media_recording_transcription_in_flight_pipe = inject(MediaRecordingTranscriptionInFlightPipe);
  protected readonly is_recording_available = this.platform.isDesktop();
  protected recording_active_state = toSignal(this.recording_service.active_state$, { initialValue: null as ActiveRecordingState | null });
  private saved_meeting_record_date = signal<Date | string | null | undefined>(null);
  private form_meeting_record_date = signal<Date | string | null | undefined>(null);
  private recording_pending_uploads = toSignal(this.recording_service.pending_uploads$, {
    initialValue: [] as RecordingPendingUploadMetadata[],
  });

  protected is_meeting_recording_deadline_not_passed = computed((): boolean =>
    this.isMeetingRecordRecordingAllowed(this.saved_meeting_record_date())
  );

  protected meeting_recording_deadline_panel_message = computed((): string => {
    if (this.is_meeting_recording_deadline_not_passed()) {
      return this.meeting_recording_deadline_message;
    }

    const form_date_would_allow_recording = this.isMeetingRecordRecordingAllowed(this.form_meeting_record_date());

    if (form_date_would_allow_recording) {
      return 'Guarda la reunión para poder grabar con la nueva fecha.';
    }

    return this.meeting_recording_deadline_message;
  });

  protected can_start_recording = computed((): boolean => {
    this.recording_active_state();
    this.media_recordings();

    return this.is_recording_available && this.recording_block_message() === null && !this.is_create;
  });

  protected can_add_meeting_recording = computed(
    (): boolean => this.can_start_recording() && this.is_meeting_recording_deadline_not_passed()
  );

  protected recording_block_message = computed((): string | null => {
    const active_recording = this.recording_active_state();

    if (active_recording !== null && this.isActiveRecordingVisibleForMeetingRecord(active_recording)) {
      return null;
    }

    const local_block_message = this.recording_service.getNewRecordingBlockedMessage();

    if (local_block_message !== null) {
      return local_block_message;
    }

    return this.getMeetingLiveRecordingBlockedMessage();
  });

  protected recording_card_view = computed((): MeetingRecordRecordingCardView => {
    const active_recording = this.recording_active_state();
    const is_visible_for_card = active_recording !== null && this.isActiveRecordingVisibleForMeetingRecord(active_recording);
    const is_live = active_recording !== null && this.isRecordingLiveStatus(active_recording.status);
    const is_upload = active_recording !== null && this.isRecordingUploadStatus(active_recording.status);
    const block_message = this.recording_block_message();
    const is_recording_live_globally = active_recording !== null && this.isRecordingLiveStatus(active_recording.status);

    let show_idle_panel = false;

    if (is_recording_live_globally) {
      show_idle_panel = false;
    } else if (active_recording === null) {
      show_idle_panel = true;
    } else if (!is_visible_for_card) {
      show_idle_panel = !is_live && !is_upload;
    } else {
      show_idle_panel = !is_live && !is_upload;
    }

    return {
      active_recording,
      block_message,
      show_live_panel: is_visible_for_card && is_live,
      show_upload_panel: is_visible_for_card && is_upload,
      show_blocked_panel: block_message !== null,
      show_deadline_blocked_panel: !this.is_meeting_recording_deadline_not_passed(),
      show_idle_panel,
    };
  });

  protected processing_media_recordings = computed((): MediaRecording[] =>
    this.media_recordings().filter(recording => this.media_recording_processing_on_server_pipe.transform(recording))
  );

  protected transcription_in_flight_media_recordings = computed((): MediaRecording[] =>
    this.media_recordings().filter(recording => this.media_recording_transcription_in_flight_pipe.transform(recording))
  );

  protected visible_meeting_record_pending_uploads = computed((): RecordingPendingUploadMetadata[] => {
    const meeting_record_id = this.meetingRecordId;
    const active_recording = this.recording_active_state();
    const pending_uploads = this.recording_pending_uploads();

    return pending_uploads.filter(pending => {
      const belongs_to_meeting_record = !meeting_record_id || pending.recordable_id === meeting_record_id || pending.recordable_id == null;

      if (!belongs_to_meeting_record) {
        return false;
      }

      return this.recording_service.shouldShowPendingUploadBanner(pending, active_recording, meeting_record_id);
    });
  });

  private company_product: CompanyProduct | undefined;
  private potential_client: PotentialClient | null = null;
  private client_company_id: number | null = null;
  private client_company_name: string | null = null;
  private roles: Role[] = [];

  constructor() {
    this.meetingRecordFormGroup = this.fb.group({
      id: [''],
      meetingable_id: ['', Validators.required],
      meetingable_type: ['', Validators.required],
      date: [new Date(), Validators.required],
      title: ['', [Validators.required, Validators.minLength(5)]],
      content: [''],
      users: [[], Validators.minLength(1)],
      exam_instance_evaluation_id: [null as number | null],
    });
    this.pending_changes_guard.registerBeforeUnload(this, this.destroy_ref);
  }

  ngOnInit(): void {
    this.destroy_ref.onDestroy(() => {
      this.unsubscribeFromMeetingRecordMediaRecordingsChannel();
    });
    this.registerPendingChangesSaveStatusTimeoutCleanupOnDestroy();

    this.initTinyMceKey();
    this.listenUserInput();
    this.fetchRoles();

    this.initFormValuesFromInput();
    this.syncFormMeetingRecordDateFromForm();
    if (this.is_create) {
      this.syncSavedMeetingRecordDateFromForm();
    }
    this.meetingRecordFormGroup
      .get('date')!
      .valueChanges.pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(date => this.form_meeting_record_date.set(date));
    this.back_route = this.resolveBackRoute(this.activatedRoute.snapshot.queryParamMap.get('from'));

    if (this.isRecruitmentMeeting()) {
      this.prepareRecruitmentContext();
    } else if (this.isUserMeeting()) {
      this.loadExamEvaluationsForUser(this.meetingableId);
    }

    if (!this.is_create) {
      this.fetchMeetingRecordAndInitCompanyProduct();
    } else {
      this.prefillDefaultAssistantsOnCreate();
      if (this.meetingableType === 'App\\Models\\CompanyProduct') {
        this.initCompanyProductFromRouteParameter();
      }
    }

    this.recording_service.recordingSessionEnded$.pipe(takeUntilDestroyed(this.destroy_ref)).subscribe(event => {
      if (this.meetingRecordId && event.recordable_id === this.meetingRecordId) {
        this.fetchMediaRecordings();
      }
    });

    if (this.meetingRecordId) {
      this.subscribeToMeetingRecordMediaRecordingsChannel();
    }

    this.listenPersonalNotesChanges();
    this.listenMeetingRecordFormAutosave();
  }

  protected setActiveActaTab(tab_id: MeetingRecordActaTabId): void {
    this.active_acta_tab.set(tab_id);
  }

  protected jumpToDiarizationAtSeconds(seconds: number): void {
    this.diarization_seek_seconds.set(seconds);
    this.active_acta_tab.set('diarization');
  }

  onUserChipEnter(event: Event): void {
    if (this.userInputTrigger?.panelOpen) {
      return;
    }

    event.preventDefault();
    this.tryQuickCreateFromTypedInput();
  }

  addUserToForm(user: User | null | undefined): void {
    if (user?.id == null) {
      return;
    }

    const current_users = (this.meetingRecordFormGroup.controls['users'].value as User[] | null) ?? [];

    if (current_users.some(current_user => current_user.id === user.id)) {
      return;
    }

    this.meetingRecordFormGroup.controls['users'].patchValue([...current_users, user]);
  }

  selectUser(event: MatAutocompleteSelectedEvent): void {
    if (event.option.value === this.create_user_option_value) {
      this.userInputValue.setValue(this.user_create_typed_name, { emitEvent: false });
      this.openAddUserDialog();
      return;
    }

    this.addUserToForm(event.option.value as User);
    this.clearUserChipInput();
    this.users_searched = [];
    this.syncAutoActiveCreateUserOption();
  }

  removeUser(idx: number): void {
    const users: User[] = this.meetingRecordFormGroup.value['users'] as User[];
    users.splice(idx, 1);
    this.meetingRecordFormGroup.controls['users'].patchValue(users);
  }

  openAddUserDialog() {
    if (this.is_opening_add_user_dialog) {
      return;
    }

    const typed_name =
      this.user_create_typed_name ||
      (typeof this.userInputValue.value === 'string' && this.userInputValue.value !== this.create_user_option_value
        ? this.userInputValue.value
        : '');

    this.is_opening_add_user_dialog = true;
    this.dialog
      .open(AddUserDialogComponent, {
        width: '750px',
        data: this.buildAddUserDialogData(typed_name),
      })
      .afterClosed()
      .subscribe((user: User | null | undefined): void => {
        this.is_opening_add_user_dialog = false;
        if (user && user.id) {
          this.addUserToForm(user);

          this.userInputValue.setValue('');
          this.user_create_typed_name = '';
        }
      });
  }

  submit(): void {
    this.forceMeetingRecordSave();
  }

  forceMeetingRecordSave(): void {
    if (!this.meetingRecordFormGroup.valid) {
      this.meetingRecordFormGroup.markAllAsTouched();
      this.snack_bar.open('Completa los campos obligatorios para guardar.', undefined, { duration: 4000 });
      return;
    }

    this.persistMeetingRecord(true).pipe(takeUntilDestroyed(this.destroy_ref)).subscribe();
  }

  canDeactivate(): boolean {
    if (this.isSubmitting) {
      return true;
    }

    // create
    return !this.meetingRecordFormGroup.dirty;
  }

  downloadPdf(): void {
    const available_pdf_section_rows = this.buildAvailablePdfSectionRows();

    if (available_pdf_section_rows.length === 0) {
      this.snack_bar.open('No hay contenido disponible para exportar a PDF.', undefined, { duration: 5000 });
      return;
    }

    this.dialog
      .open(CheckboxSelectorDialogComponent, {
        data: {
          dialog_title: 'Descargar PDF del acta',
          dialog_ok_button: 'Descargar',
          dialog_cancel_button: 'Cancelar',
          data: available_pdf_section_rows,
          initial_selected_values: available_pdf_section_rows.map(row => row.value),
        },
      })
      .afterClosed()
      .subscribe((selected_sections: MeetingRecordActaTabId[] | undefined): void => {
        if (!selected_sections?.length) {
          return;
        }

        this.api.downloadMeetingRecordPdf(this.meetingRecordId.toString(), selected_sections).subscribe({
          next: data => {
            this.utils.downloadPdfFromBlobResponse(data);
          },
          error: (): void => {
            this.snack_bar.open('No se pudo generar el PDF del acta.', undefined, { duration: 5000 });
          },
        });
      });
  }

  onShellDropzoneChange(event: { addedFiles?: File[] } | null): void {
    if (!event?.addedFiles?.length || !this.can_manage_attachments()) {
      return;
    }

    this.uploadMeetingRecordAttachments(event.addedFiles);
  }

  triggerAttachmentFilePicker(file_input: HTMLInputElement): void {
    if (!this.can_manage_attachments()) {
      return;
    }

    file_input.click();
  }

  onAttachmentFileInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files ? Array.from(input.files) : [];
    input.value = '';

    if (files.length === 0 || !this.can_manage_attachments()) {
      return;
    }

    this.uploadMeetingRecordAttachments(files);
  }

  downloadMeetingRecordAttachment(attachment: Attachment): void {
    if (!this.meetingRecordId) {
      return;
    }

    this.api
      .downloadMeetingRecordAttachment(this.meetingRecordId, attachment.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: response => {
          const blob = new Blob([response.body as BlobPart]);
          saveAs(blob, attachment.file_name || 'archivo');
        },
        error: (): void => {
          this.snack_bar.open('No se pudo descargar el archivo.', undefined, { duration: 5000 });
        },
      });
  }

  deleteMeetingRecordAttachment(attachment: Attachment): void {
    if (!this.meetingRecordId || !this.can_manage_attachments()) {
      return;
    }

    if (!confirm(`¿Seguro que quieres eliminar el archivo "${attachment.file_name}"?`)) {
      return;
    }

    this.api
      .deleteMeetingRecordAttachment(this.meetingRecordId, attachment.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (): void => {
          this.attachments.update(current => current.filter(item => item.id !== attachment.id));
          this.change_detector_ref.markForCheck();
        },
        error: (): void => {
          this.snack_bar.open('No se pudo eliminar el archivo.', undefined, { duration: 5000 });
        },
      });
  }

  private uploadMeetingRecordAttachments(files: File[]): void {
    if (!this.meetingRecordId || files.length === 0) {
      return;
    }

    const allowed_files = this.filterAllowedMeetingRecordAttachmentFiles(files);
    if (allowed_files.length === 0) {
      return;
    }

    this.is_uploading_attachments.set(true);
    this.api
      .attachMeetingRecordFiles(this.meetingRecordId, allowed_files)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: uploaded => {
          this.attachments.update(current => [...uploaded, ...current]);
          this.is_uploading_attachments.set(false);
          this.snack_bar.open(uploaded.length === 1 ? 'Archivo subido correctamente.' : `${uploaded.length} archivos subidos.`, undefined, {
            duration: 3000,
          });
          this.change_detector_ref.markForCheck();
        },
        error: (): void => {
          this.is_uploading_attachments.set(false);
          this.snack_bar.open('No se pudieron subir los archivos.', undefined, { duration: 5000 });
          this.change_detector_ref.markForCheck();
        },
      });
  }

  private filterAllowedMeetingRecordAttachmentFiles(files: File[]): File[] {
    const accepted_extensions = this.attachment_accepted_types.split(',').map(extension => extension.replace('.', '').toLowerCase());
    const size_ok = files.filter(file => file.size <= this.attachment_max_file_size_bytes);
    const type_ok = size_ok.filter(file => {
      const extension = (file.name.split('.').pop() ?? '').toLowerCase();
      return accepted_extensions.includes(extension);
    });

    const rejected_size = files.length - size_ok.length;
    const rejected_type = size_ok.length - type_ok.length;

    if (rejected_size > 0) {
      this.snack_bar.open(
        rejected_size === 1 ? 'El archivo supera el límite de 10 MB.' : `${rejected_size} archivos superan el límite de 10 MB.`,
        undefined,
        { duration: 5000 }
      );
    }

    if (rejected_type > 0) {
      this.snack_bar.open('Tipo de archivo no permitido. Solo documentos, hojas de cálculo, imágenes, ZIP/RAR y PDF.', undefined, {
        duration: 5000,
      });
    }

    return type_ok;
  }

  private buildAvailablePdfSectionRows(): SelectorDialogDataRow[] {
    return this.acta_tabs
      .filter(tab => this.hasPdfSectionContent(tab.id))
      .map(tab => ({
        value: tab.id,
        textToShow: tab.label,
      }));
  }

  private hasPdfSectionContent(section_id: MeetingRecordActaTabId): boolean {
    switch (section_id) {
      case 'acta':
        return !this.isMeetingRecordHtmlEmpty(this.meetingRecordFormGroup.value.content);
      case 'ai_summary':
        return !this.isMeetingRecordHtmlEmpty(this.ai_summary_html());
      case 'diarization':
        return this.media_recordings().some(
          media_recording =>
            media_recording.transcription_status === ('completed' as MediaRecordingTranscriptionStatus) &&
            resolveMediaRecordingDiarizationInterventions(media_recording).length > 0
        );
      case 'personal_notes':
        return !this.is_create && !this.isPersonalNotesHtmlEmpty(this.personal_notes_control.value);
      default:
        return false;
    }
  }

  protected readonly meeting_recording_deadline_message =
    'No se pueden añadir grabaciones cuando han pasado más de 24 horas desde la fecha de la reunión.';

  openImportAudioFilePicker(): void {
    if (!this.meetingRecordId) {
      this.snack_bar.open('Guarda el acta antes de importar una grabación.', undefined, { duration: 4000 });

      return;
    }

    if (!this.assertCanAddMeetingRecording()) {
      return;
    }

    const input_element = document.createElement('input');
    input_element.type = 'file';
    input_element.accept = 'audio/*,video/mp4,video/webm,video/quicktime';
    input_element.addEventListener('change', () => {
      const file = input_element.files?.[0];

      if (!file) {
        return;
      }

      void this.importMediaRecordingAudio(file);
    });
    input_element.click();
  }

  openImportYoutubeDialog(): void {
    if (!this.meetingRecordId) {
      this.snack_bar.open('Guarda el acta antes de importar una grabación.', undefined, { duration: 4000 });

      return;
    }

    const dialog_ref = this.dialog.open(InputDialogComponent, {
      width: '520px',
      data: {
        title: 'Importar desde YouTube',
        description: 'Pega la URL del vídeo de YouTube.',
        type: 'url',
        placeholder: 'https://www.youtube.com/watch?v=...',
        label: 'URL de YouTube',
        close_button_text: 'Importar',
      },
    });

    dialog_ref.afterClosed().subscribe((youtube_url: string | undefined) => {
      const trimmed_url = youtube_url?.trim();

      if (!trimmed_url) {
        return;
      }

      void this.importMediaRecordingFromYoutube(trimmed_url);
    });
  }

  async openRecordingSetupDialog(): Promise<void> {
    const blocked_message = this.recording_block_message();

    if (blocked_message !== null) {
      this.snack_bar.open(blocked_message, undefined, { duration: 6000 });

      return;
    }

    if (!this.assertCanAddMeetingRecording()) {
      return;
    }

    if (!this.can_start_recording()) {
      return;
    }

    const dialog_ref = this.dialog.open(RecordingSetupDialogComponent, {
      width: '560px',
      maxWidth: 'calc(100vw - 32px)',
      disableClose: true,
      data: {
        is_electron: this.platform.isElectronApp(),
      },
    });

    const setup_result = await firstValueFrom(dialog_ref.afterClosed(), { defaultValue: undefined });

    if (setup_result === undefined) {
      return;
    }

    await this.startRecordingFromSetup(setup_result);
  }

  private async startRecordingFromSetup(setup_result: RecordingSetupDialogResult): Promise<void> {
    const concept = (this.meetingRecordFormGroup.value.title as string)?.trim() || 'Grabación de reunión';
    const include_screen = setup_result.mode === 'screen';

    try {
      await this.recording_service.startRecording({
        concept,
        include_microphone: setup_result.include_microphone,
        include_screen,
        microphone_device_id: setup_result.include_microphone ? setup_result.microphone_device_id : null,
        recordable_type: this.meetingRecordId ? 'App\\Models\\MeetingRecord' : null,
        recordable_id: this.meetingRecordId ?? null,
        electron_display_selection:
          include_screen && setup_result.electron_screen_source_id !== null
            ? {
                source_id: setup_result.electron_screen_source_id,
                include_system_audio: setup_result.electron_include_system_audio,
              }
            : null,
      });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'No se pudo iniciar la grabación.';
      this.snack_bar.open(message, undefined, { duration: 5000 });
    }
  }

  async pauseRecording(): Promise<void> {
    await this.recording_service.pauseRecording();
  }

  async resumeRecording(): Promise<void> {
    await this.recording_service.resumeRecording();
  }

  async stopRecording(): Promise<void> {
    await this.recording_service.stopRecording();
    this.fetchMediaRecordings();
  }

  async discardRecording(): Promise<void> {
    await this.recording_service.discardRecording();
    this.fetchMediaRecordings();
  }

  private assertCanAddMeetingRecording(): boolean {
    if (this.is_meeting_recording_deadline_not_passed()) {
      return true;
    }

    const form_date = this.meetingRecordFormGroup.get('date')!.value as Date | string | null | undefined;
    const form_date_would_allow_recording = this.isMeetingRecordRecordingAllowed(form_date);
    const message = form_date_would_allow_recording
      ? 'Guarda la reunión para poder grabar con la nueva fecha.'
      : this.meeting_recording_deadline_message;

    this.snack_bar.open(message, undefined, { duration: 6000 });

    return false;
  }

  private isActiveRecordingVisibleForMeetingRecord(active_recording: ActiveRecordingState): boolean {
    if (!this.meetingRecordId) {
      return true;
    }

    return active_recording.recordable_id === this.meetingRecordId || active_recording.recordable_id === null;
  }

  private getMeetingLiveRecordingBlockedMessage(): string | null {
    const blocking_recording = this.findBlockingLiveMeetingRecording();

    if (blocking_recording === null) {
      return null;
    }

    const current_user_id = this.userService.getCurrentUser()!.id;
    const creator_name = blocking_recording.created_by_user!.full_name!.trim();

    if (current_user_id != null && blocking_recording.created_by_user_id === current_user_id) {
      return 'Ya hay una grabación en curso en esta reunión. Finalízala antes de iniciar otra.';
    }

    return `${creator_name} ya está grabando esta reunión. Espera a que finalice antes de iniciar otra.`;
  }

  private findBlockingLiveMeetingRecording(): MediaRecording | null {
    const active_recording = this.recording_active_state();

    return (
      this.media_recordings().find((recording: MediaRecording): boolean => {
        if (recording.recording_status !== 'recording' && recording.recording_status !== 'paused') {
          return false;
        }

        return !this.isLocalActiveLiveRecording(recording, active_recording);
      }) ?? null
    );
  }

  private isLocalActiveLiveRecording(recording: MediaRecording, active_recording: ActiveRecordingState | null): boolean {
    if (active_recording === null || !this.isRecordingLiveStatus(active_recording.status)) {
      return false;
    }

    if (active_recording.server_id !== null && active_recording.server_id === recording.id) {
      return true;
    }

    return active_recording.client_local_id === recording.client_local_id;
  }

  private isRecordingLiveStatus(status: ActiveRecordingState['status']): boolean {
    return status === 'recording' || status === 'paused' || status === 'stopping';
  }

  private isRecordingUploadStatus(status: ActiveRecordingState['status']): boolean {
    return ['uploading', 'pending_upload', 'upload_failed', 'processing', 'failed'].includes(status);
  }

  private syncSavedMeetingRecordDateFromForm(): void {
    this.syncSavedMeetingRecordDate(this.meetingRecordFormGroup.get('date')!.value as Date | string | null | undefined);
  }

  private syncFormMeetingRecordDateFromForm(): void {
    this.form_meeting_record_date.set(this.meetingRecordFormGroup.get('date')!.value as Date | string | null | undefined);
  }

  private syncSavedMeetingRecordDate(meeting_date: Date | string | null | undefined): void {
    this.saved_meeting_record_date.set(meeting_date);
    this.form_meeting_record_date.set(meeting_date);
  }

  async retryRecordingUpload(client_local_id: string): Promise<void> {
    const server_recording = this.media_recordings().find(recording => recording.client_local_id === client_local_id) ?? null;

    try {
      const retry_context = await this.recording_service.retryMediaRecordingUploadHybrid(client_local_id, server_recording);
      this.snack_bar.open(retry_context.retry_summary ?? 'Reintento iniciado.', undefined, { duration: 6000 });
      this.fetchMediaRecordings();
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : 'No se pudo reintentar la subida.';
      this.snack_bar.open(message, undefined, { duration: 6000 });
    }
  }

  async discardFailedRecordingUpload(client_local_id: string): Promise<void> {
    const discarded = await this.recording_service.discardFailedOrPendingUpload(client_local_id);

    if (discarded) {
      this.snack_bar.open('Subida descartada. Ya puedes iniciar una nueva grabación.', undefined, { duration: 5000 });
      this.fetchMediaRecordings();
    }
  }

  openMediaRecordingsDialog(): void {
    if (!this.meetingRecordId) {
      return;
    }

    const dialog_ref = this.dialog.open(MeetingRecordMediaRecordingsDialogComponent, {
      width: '560px',
      maxWidth: 'calc(100vw - 32px)',
      data: {
        meeting_record_id: this.meetingRecordId,
        media_recordings: this.media_recordings(),
        assistant_users: (this.meetingRecordFormGroup.value['users'] as User[]) ?? [],
        can_edit_diarization: true,
        return_url: this.router.url.split('?')[0],
        meetingable_type: this.meetingableType,
        meetingable_id: this.meetingableId,
      },
    });

    dialog_ref.afterClosed().subscribe(() => {
      this.fetchMediaRecordings();
    });
  }

  trackByUserId(index: number, user: User) {
    return user?.id || index;
  }

  get selected_exam_instance_evaluation(): ExamInstanceEvaluation | null {
    const selected_evaluation_id = this.meetingRecordFormGroup.value['exam_instance_evaluation_id'] as number | null;
    if (selected_evaluation_id == null) {
      return null;
    }

    const evaluation_from_list = this.exam_instance_evaluations.find(evaluation => evaluation.id === selected_evaluation_id);

    if (evaluation_from_list != null) {
      return evaluation_from_list;
    }

    if (this.linked_exam_instance_evaluation?.id === selected_evaluation_id) {
      return this.linked_exam_instance_evaluation;
    }

    return null;
  }

  get meetingable_card_description(): string {
    if (this.isRecruitmentMeeting()) {
      const selected_phase_id = this.meetingRecordFormGroup.value['meetingable_id'] as number | null;
      const selected_phase = this.candidate_phase_progress_options.find(phase => phase.id === selected_phase_id);
      const phase_label = selected_phase?.job_vacancy_phase?.name ?? (selected_phase_id ? `Fase #${selected_phase_id}` : 'Sin fase');
      return `Entrevistado: ${this.interviewed_user_label} · Fase: ${phase_label}`;
    }

    if (this.meetingableType === 'App\\Models\\CompanyProduct') {
      return this.company_product?.title ?? this.meetingable_label ?? `Producto #${this.meetingableId}`;
    }

    if (this.meetingableType === 'App\\Models\\User') {
      return this.meetingable_label || `Usuario #${this.meetingableId}`;
    }

    if (this.meetingableType === 'App\\Models\\PotentialClient') {
      return this.meetingable_label || `Lead #${this.meetingableId}`;
    }

    return `Elemento #${this.meetingableId}`;
  }

  get selected_candidate_phase_label(): string {
    const selected_phase_id = this.meetingRecordFormGroup.value['meetingable_id'] as number | null;
    const selected_phase = this.candidate_phase_progress_options.find(phase => phase.id === selected_phase_id);
    return selected_phase?.job_vacancy_phase?.name ?? (selected_phase_id ? `Fase #${selected_phase_id}` : 'Sin fase');
  }

  get evaluation_user_id(): number | null {
    if (this.isRecruitmentMeeting()) {
      return this.candidate_user_id;
    }

    if (this.isUserMeeting()) {
      return this.meetingableId;
    }

    return null;
  }

  get can_have_exam(): boolean {
    return this.isUserMeeting() || this.isRecruitmentMeeting();
  }

  get can_manage_exams(): boolean {
    return this.evaluation_user_id !== null;
  }

  get has_linked_exam_evaluation(): boolean {
    const exam_instance_evaluation_id = this.meetingRecordFormGroup.value['exam_instance_evaluation_id'] as number | null;

    return exam_instance_evaluation_id != null;
  }

  get exam_state_label(): string {
    const selected_evaluation = this.selected_exam_instance_evaluation;
    if (selected_evaluation === null) {
      return 'Sin evaluación asociada';
    }

    return ExamInstanceEvaluationStatusEnumLabels[selected_evaluation.status] ?? selected_evaluation.status;
  }

  open_exam_template_selector_for_creation(): void {
    if (!this.can_manage_exams) {
      return;
    }

    this.api
      .getExamInstances({ per_page: 500, order_by: 'created_at:desc' })
      .subscribe((response: ExamInstance[] | { data: ExamInstance[] }): void => {
        const exam_instances = Array.isArray(response) ? response : response.data;
        const selector_data: SelectorDialogDataRow[] = exam_instances.map(exam_instance => ({
          value: exam_instance.id,
          textToShow: exam_instance.name,
        }));

        const exam_dialog_ref = this.dialog.open(SelectorDialogComponent, {
          data: {
            dialog_title: 'Selecciona examen',
            dialog_ok_button: 'Siguiente',
            dialog_cancel_button: 'Cancelar',
            data: selector_data,
          },
        });

        exam_dialog_ref.afterClosed().subscribe((selected_exam_instance_id: number | undefined): void => {
          if (selected_exam_instance_id == null) {
            return;
          }

          this.create_evaluation_for_meeting_user(selected_exam_instance_id);
        });
      });
  }

  open_exam_instance_evaluation_detail(): void {
    const selected_evaluation = this.selected_exam_instance_evaluation;

    if (selected_evaluation != null) {
      this.navigateToExamEvaluationDetail(selected_evaluation);
      return;
    }

    const evaluation_id = this.meetingRecordFormGroup.value['exam_instance_evaluation_id'] as number | null;

    if (evaluation_id == null) {
      return;
    }

    this.api.getExamInstanceEvaluation(evaluation_id, { with: 'exam_instance' }).subscribe((evaluation: ExamInstanceEvaluation): void => {
      this.linked_exam_instance_evaluation = evaluation;
      this.mergeExamInstanceEvaluation(evaluation);
      this.navigateToExamEvaluationDetail(evaluation);
    });
  }

  private processMeetingRecordAndInitCompanyProduct(data: MeetingRecord) {
    this.summary_generation_status.set(data.summary_generation_status ?? null);
    this.ai_summary_html.set(data.ai_summary_html ?? null);
    this.attachments.set(data.attachments ?? []);
    this.can_manage_attachments.set(!this.is_create);
    this.meetingRecordFormGroup.patchValue({
      id: data.id,
      meetingable_id: data.meetingable_id,
      meetingable_type: data.meetingable_type,
      date: data.date,
      title: data.title,
      content: data.content ?? '',
      users: data.users ?? [],
      exam_instance_evaluation_id: data.exam_instance_evaluation_id ?? null,
    });
    this.syncSavedMeetingRecordDate(data.date);

    if (data.meetingable && data.meetingable_type === 'App\\Models\\User') {
      const user = data.meetingable as UserModel;
      this.meetingable_label = `${user.name} ${user.surnames ?? ''}`.trim();
    }
    if (data.meetingable && data.meetingable_type === 'App\\Models\\CompanyProduct') {
      const company_product = data.meetingable as CompanyProduct;
      this.company_product = company_product;
      this.meetingable_label = company_product.title;
      this.loadClientCompanyById(company_product.company_id);
    }
    if (data.meetingable && data.meetingable_type === 'App\\Models\\PotentialClient') {
      const potential_client = data.meetingable as PotentialClient;
      this.potential_client = potential_client;
      this.meetingable_label = this.buildPotentialClientDisplayLabel(potential_client);
      this.resolvePotentialClientCompany(potential_client);
    }

    if (data.exam_instance_evaluation) {
      this.linked_exam_instance_evaluation = data.exam_instance_evaluation;
      this.mergeExamInstanceEvaluation(data.exam_instance_evaluation);
    }

    const evaluation_user_id = this.evaluation_user_id;
    if (evaluation_user_id !== null) {
      this.loadExamEvaluationsForUser(evaluation_user_id);
    }

    this.meetingRecordFormGroup.markAsPristine(); // marcamos el form como pristine ya que al hacer el patchValue se queda dirty
    this.last_saved_at.set(data.updated_at ? new Date(data.updated_at) : null);
    this.pending_changes_save_status.reset();
    this.syncMeetingRecordRealtimeUpdates();

    if (this.isRecruitmentMeeting()) {
      this.prepareRecruitmentContext();
    }

    if (!this.initial_acta_tab_resolved) {
      this.active_acta_tab.set(this.resolveInitialActaTab(data));
      this.initial_acta_tab_resolved = true;
    }
  }

  private fetchMeetingRecordAndInitCompanyProduct(refresh_personal_notes = true) {
    this.api.getMeetingRecord(this.meetingRecordId.toString(), { with: this.buildMeetingRecordFetchWithParam() }).subscribe({
      next: data => {
        this.processMeetingRecordAndInitCompanyProduct(data);
        if (refresh_personal_notes) {
          this.fetchPersonalNotes();
        }
        this.fetchMediaRecordings();
      },
      error: (): void => {
        this.snack_bar.open('No se pudo cargar el acta.', undefined, { duration: 5000 });
        this.change_detector_ref.markForCheck();
      },
    });
  }

  private persistPersonalNotesNow(): Observable<void> {
    if (this.is_create || !this.meetingRecordId) {
      return of(undefined);
    }

    const normalized_personal_notes = this.isPersonalNotesHtmlEmpty(this.personal_notes_control.value)
      ? null
      : this.personal_notes_control.value;

    return this.api.updateMeetingRecordPersonalNotes(this.meetingRecordId, normalized_personal_notes).pipe(
      map(() => undefined),
      catchError(() => of(undefined))
    );
  }

  private fetchPersonalNotes(): void {
    if (!this.meetingRecordId) {
      return;
    }

    this.api.getMeetingRecordPersonalNotes(this.meetingRecordId).subscribe({
      next: (response): void => {
        this.personal_notes_control.setValue(response.personal_notes ?? '', { emitEvent: false });
        this.change_detector_ref.markForCheck();
      },
      error: (): void => {
        this.personal_notes_control.setValue('', { emitEvent: false });
      },
    });
  }

  private fetchMediaRecordings(): void {
    if (!this.meetingRecordId) {
      return;
    }

    this.api.getMeetingRecordMediaRecordings(this.meetingRecordId).subscribe(data => {
      this.media_recordings.set(data);
      this.change_detector_ref.markForCheck();
    });
  }

  private subscribeToMeetingRecordMediaRecordingsChannel(): void {
    if (!this.meetingRecordId || this.meeting_record_pusher_unsubscribe !== null) {
      return;
    }

    this.meeting_record_pusher_unsubscribe = this.pusher.subscribeToMeetingRecordChannel(
      this.meetingRecordId,
      update => {
        const existing_recording = this.media_recordings().some((recording: MediaRecording): boolean => {
          return recording.id === update.media_recording_id;
        });

        if (!existing_recording) {
          this.fetchMediaRecordings();

          return;
        }

        this.media_recordings.update(recordings => applyMeetingRecordMediaRecordingPusherUpdate(recordings, update));

        const should_refetch_after_recording_change =
          update.transcription_status === 'completed' || update.recording_status === 'completed';

        if (should_refetch_after_recording_change) {
          this.refetchMeetingRecordStateAfterMediaRecordingChange();

          return;
        }

        this.change_detector_ref.markForCheck();
      },
      update => {
        this.applySummaryGenerationPusherUpdate(update);
      }
    );
  }

  private syncMeetingRecordRealtimeUpdates(): void {
    if (!this.meetingRecordId) {
      this.unsubscribeFromMeetingRecordMediaRecordingsChannel();

      return;
    }

    if (this.meeting_record_pusher_unsubscribe === null) {
      this.subscribeToMeetingRecordMediaRecordingsChannel();
    }
  }

  private applySummaryGenerationPusherUpdate(update: {
    summary_generation_status: MeetingRecordSummaryGenerationStatus | null;
    summary_generation_error: string | null;
    should_refetch_summary?: boolean;
  }): void {
    const was_summary_generation_processing = this.summary_generation_status() === 'processing';

    this.summary_generation_status.set(update.summary_generation_status);

    if (update.summary_generation_status === 'failed' && update.summary_generation_error) {
      this.snack_bar.open(update.summary_generation_error, 'Cerrar', { duration: 6000 });
    }

    const should_refetch_summary =
      update.should_refetch_summary === true || (was_summary_generation_processing && update.summary_generation_status !== 'processing');

    if (should_refetch_summary) {
      this.refetchMeetingRecordSummaryFromApi(was_summary_generation_processing);

      return;
    }

    this.change_detector_ref.markForCheck();
  }

  protected onSummaryGenerationStatusChange(status: MeetingRecordSummaryGenerationStatus | null): void {
    this.summary_generation_status.set(status);
    this.change_detector_ref.markForCheck();
  }

  private unsubscribeFromMeetingRecordMediaRecordingsChannel(): void {
    if (this.meeting_record_pusher_unsubscribe === null) {
      return;
    }

    this.meeting_record_pusher_unsubscribe();
    this.meeting_record_pusher_unsubscribe = null;
  }

  private registerPendingChangesSaveStatusTimeoutCleanupOnDestroy(): void {
    this.destroy_ref.onDestroy((): void => {
      this.pending_changes_save_status.destroy();
    });
  }

  private async linkActiveRecordingToMeetingRecord(meeting_record_id: number): Promise<void> {
    const active = this.recording_service.getActiveState();

    if (!active?.server_id) {
      return;
    }

    await firstValueFrom(
      this.api.updateMediaRecording(active.server_id, {
        recordable_type: 'App\\Models\\MeetingRecord',
        recordable_id: meeting_record_id,
      })
    );

    if (this.meetingRecordId === meeting_record_id) {
      this.fetchMediaRecordings();
    }
  }

  private initTinyMceKey() {
    this.tinyMceApiKey = this.tinymce.getKey();
  }

  private clearUserChipInput(): void {
    if (this.user_chip_input) {
      this.user_chip_input.nativeElement.value = '';
    }
    this.userInputValue.setValue('');
    this.user_create_typed_name = '';
  }

  private tryQuickCreateFromTypedInput(): void {
    const typed_value = this.userInputValue.value;
    const value = typeof typed_value === 'string' ? typed_value.trim() : '';
    if (!value || value === this.create_user_option_value) {
      return;
    }

    const user_to_create = this.buildQuickCreateUserPayload(value);

    if (confirm(this.getQuickCreateUserConfirmMessage())) {
      this.api.createUser(user_to_create as unknown as User).subscribe((data: User): void => {
        this.addUserToForm(data);
      });
    }

    this.clearUserChipInput();
  }

  private listenUserInput() {
    this.userInputValue.valueChanges.subscribe((search_str: string | null) => {
      if (search_str === this.create_user_option_value || typeof search_str !== 'string') {
        return;
      }

      const typed = search_str.trim();
      this.user_create_typed_name = typed.length >= 3 ? typed : '';
      if (!this.user_create_typed_name) {
        this.users_searched = [];
      }
      this.syncAutoActiveCreateUserOption();
    });

    this.userInputValue.valueChanges.pipe(debounceTime(500)).subscribe(async search_str => {
      if (search_str === this.create_user_option_value || typeof search_str !== 'string') {
        return;
      }

      if (search_str && search_str.length >= 3) {
        const promises: Promise<User[]>[] = [];

        if (this.meetingableType === 'App\\Models\\CompanyProduct') {
          promises.push(...this.fetchProductionTeamAndBusinessRelatedUsers(search_str));
        } else {
          promises.push(this.fetchAllUsersSearch(search_str));
        }

        this.users_searched = (await Promise.all(promises))
          .reduce((prev: User[], curr: User[]): User[] => {
            return prev.concat(curr.filter(new_user => !prev.find(prev_u => prev_u.id === new_user.id)));
          }, [])
          .filter(u => !this.meetingRecordFormGroup.value['users'].find((u2: User) => u2.id === u.id));
      } else {
        this.users_searched = [];
      }

      this.syncAutoActiveCreateUserOption();
    });
  }

  private syncAutoActiveCreateUserOption(): void {
    this.auto_active_create_user_option = this.user_create_typed_name.length > 0 && this.users_searched.length === 0;
  }

  private initFormValuesFromInput() {
    this.meetingRecordFormGroup.patchValue({
      id: this.meetingRecordId,
      meetingable_id: this.meetingableId,
      meetingable_type: this.meetingableType,
    });

    this.is_create = !this.meetingRecordId || this.meetingRecordId <= 0;

    this.loadMeetingableLabelForCards();
  }

  private isRecruitmentMeeting(): boolean {
    return this.meetingableType === 'App\\Models\\JobVacancyCandidatePhaseProgress';
  }

  private buildMeetingRecordFetchWithParam(): string {
    const with_relations = ['users..role', 'exam_instance_evaluation.exam_instance', 'attachments'];

    if (this.isRecruitmentMeeting()) {
      with_relations.push('meetingable.job_vacancy_phase');
    } else {
      with_relations.push('meetingable');
    }

    return with_relations.join(',');
  }

  private isUserMeeting(): boolean {
    return this.meetingableType === 'App\\Models\\User';
  }

  private prepareRecruitmentContext(): void {
    if (this.jobVacancyCandidateId == null) {
      this.meetingRecordFormGroup.controls['meetingable_id'].setErrors({ required: true });
      return;
    }

    this.api
      .getJobCandidate(this.jobVacancyCandidateId, {
        with: 'job_vacancy_candidate_phase_progress.job_vacancy_phase,user',
      })
      .subscribe((job_candidate: JobVacancyCandidate): void => {
        this.candidate_user_id = job_candidate.user_id;
        this.interviewed_user_label = job_candidate.full_name ?? '—';
        this.interviewed_user = this.resolveInterviewedUserFromCandidate(job_candidate);
        const phase_progress_options = [...(job_candidate.job_vacancy_candidate_phase_progress ?? [])].sort((a, b) =>
          b.entered_at.localeCompare(a.entered_at)
        );
        this.candidate_phase_progress_options = phase_progress_options;

        if (this.is_create && phase_progress_options.length > 0 && !this.meetingRecordFormGroup.value.meetingable_id) {
          const active_phase_progress = phase_progress_options.find(option => option.discarded_at == null && option.completed_at == null);
          this.meetingRecordFormGroup.controls['meetingable_id'].patchValue(active_phase_progress?.id ?? phase_progress_options[0].id);
        }

        if (job_candidate.user_id) {
          this.loadExamEvaluationsForUser(job_candidate.user_id);
        }

        if (this.is_create) {
          this.prefillInterviewedUserAssistant();
          this.listenRecruitmentPhaseSelectionForAssistants();
        }
      });
  }

  private fetchProductionTeamAndBusinessRelatedUsers(search_str: string): Promise<User[]>[] {
    return [
      this.api
        .getBisualProductionTeamNowAndFuture(this.meetingableId.toString(), { search: search_str, with: 'user' })
        .pipe(
          map(p => {
            return p.map(pum => pum.user);
          })
        )
        .toPromise() as Promise<User[]>,
      this.api
        .getUsers({ search: search_str, 'role-slug': 'client', company_id: this.company_product!.company_id })
        .pipe(map(data => data.data))
        .toPromise() as Promise<User[]>,
    ];
  }

  private fetchAllUsersSearch(search_str: string): Promise<User[]> {
    return this.api
      .getUsers({ search: search_str, with: 'role' })
      .pipe(map(data => data.data))
      .toPromise() as Promise<User[]>;
  }

  private fetchRoles() {
    this.api.getRoles().subscribe(data => {
      this.roles = data;
    });
  }

  private getRoleBySlug(slug: string) {
    return this.roles.find(r => r.slug === slug);
  }

  private initCompanyProductFromRouteParameter() {
    const company_product_id: number = +((this.activatedRoute.snapshot.parent?.paramMap.get('id') ??
      this.activatedRoute.snapshot.parent?.parent?.paramMap.get('id')) as string);
    this.api.getCompanyProduct(company_product_id.toString()).subscribe((data: CompanyProduct): void => {
      this.company_product = data;
      this.loadClientCompanyById(data.company_id);
    });
  }

  private buildAddUserDialogData(name: string = ''): AddUserDialogData {
    const client_defaults = this.getClientUserCreationDefaults();

    if (!client_defaults) {
      return { name };
    }

    return {
      name,
      ...client_defaults,
      lock_client_fields: true,
    };
  }

  private getClientUserCreationDefaults(): {
    role: RoleSlugEnum.CLIENT;
    client_role: ClientRoleEnum.BUSINESS;
    company_id?: number;
    company_name?: string;
  } | null {
    if (this.meetingableType === 'App\\Models\\CompanyProduct' && this.company_product?.company_id) {
      return {
        role: RoleSlugEnum.CLIENT,
        client_role: ClientRoleEnum.BUSINESS,
        company_id: this.company_product.company_id,
        company_name: this.client_company_name ?? undefined,
      };
    }

    if (this.meetingableType === 'App\\Models\\PotentialClient') {
      return {
        role: RoleSlugEnum.CLIENT,
        client_role: ClientRoleEnum.BUSINESS,
        company_id: this.client_company_id ?? this.company_product?.company_id ?? undefined,
        company_name: this.potential_client?.company_name ?? this.client_company_name ?? undefined,
      };
    }

    return null;
  }

  private buildQuickCreateUserPayload(name: string): {
    name: string;
    role: RoleSlugEnum;
    client_role: ClientRoleEnum | null;
    company_id?: number;
    password_option: PasswordOptionEnum;
  } {
    const client_defaults = this.getClientUserCreationDefaults();

    if (client_defaults) {
      return {
        name,
        role: client_defaults.role,
        client_role: client_defaults.client_role,
        company_id: client_defaults.company_id,
        password_option: PasswordOptionEnum.WITHOUT_PASSWORD_NO_NOTIFY,
      };
    }

    return {
      name,
      role: RoleSlugEnum.WORKER,
      client_role: null,
      password_option: PasswordOptionEnum.WITHOUT_PASSWORD_NO_NOTIFY,
    };
  }

  private getQuickCreateUserConfirmMessage(): string {
    const client_defaults = this.getClientUserCreationDefaults();

    if (client_defaults) {
      const company_label = client_defaults.company_name ?? 'la empresa cliente';

      return `¿Estás seguro que quieres crear este usuario como miembro de ${company_label}? No se enviará ninguna notificación.`;
    }

    return '¿Estás seguro que quieres crear este usuario como trabajador? No se enviará ninguna notificación.';
  }

  private loadClientCompanyById(company_id: number | null | undefined): void {
    if (!company_id) {
      return;
    }

    this.client_company_id = company_id;
    this.api.getCompany(company_id.toString()).subscribe(company => {
      this.client_company_name = company.fact_name;
    });
  }

  private resolvePotentialClientCompany(potential_client: PotentialClient): void {
    const company_name = potential_client.company_name?.trim();

    if (!company_name) {
      return;
    }

    this.client_company_name = company_name;

    this.api.getCompanies({ search: company_name }).subscribe(response => {
      const normalized_name = company_name.toLowerCase();
      const exact_match = response.data.find(company => company.fact_name.trim().toLowerCase() === normalized_name);
      const company = exact_match ?? response.data[0] ?? null;

      if (company) {
        this.client_company_id = company.id;
        this.client_company_name = company.fact_name;
      }
    });
  }

  private prefillDefaultAssistantsOnCreate(): void {
    this.addUserToForm(this.userService.getCurrentUser());
  }

  private prefillInterviewedUserAssistant(): void {
    this.addUserToForm(this.interviewed_user);
  }

  private listenRecruitmentPhaseSelectionForAssistants(): void {
    this.meetingRecordFormGroup.controls['meetingable_id'].valueChanges.subscribe((): void => {
      this.prefillInterviewedUserAssistant();
    });
  }

  private resolveInterviewedUserFromCandidate(job_candidate: JobVacancyCandidate): User | null {
    if (job_candidate.user != null) {
      return job_candidate.user;
    }

    const interviewed_user_id = job_candidate.user_id ?? null;
    if (interviewed_user_id == null) {
      return null;
    }

    const full_name_parts = (job_candidate.full_name ?? '')
      .trim()
      .split(/\s+/)
      .filter(part => part.length > 0);

    return {
      id: interviewed_user_id,
      name: full_name_parts[0] ?? job_candidate.full_name ?? '',
      surnames: full_name_parts.slice(1).join(' '),
    } as User;
  }

  private loadMeetingableLabelForCards(): void {
    if (!this.is_create) {
      return;
    }

    if (this.meetingableType === 'App\\Models\\User') {
      this.api.getUser(this.meetingableId.toString()).subscribe((user: UserModel): void => {
        this.meetingable_label = `${user.name} ${user.surnames ?? ''}`.trim();
      });
      return;
    }

    if (this.meetingableType === 'App\\Models\\CompanyProduct') {
      this.api.getCompanyProduct(this.meetingableId.toString()).subscribe((company_product: CompanyProduct): void => {
        this.company_product = company_product;
        this.meetingable_label = company_product.title;
        this.loadClientCompanyById(company_product.company_id);
      });
      return;
    }

    if (this.meetingableType === 'App\\Models\\PotentialClient') {
      this.api.getPotentialClient(this.meetingableId.toString()).subscribe((potential_client: PotentialClient): void => {
        this.potential_client = potential_client;
        this.meetingable_label = this.buildPotentialClientDisplayLabel(potential_client);
        this.resolvePotentialClientCompany(potential_client);
      });
    }
  }

  private buildPotentialClientDisplayLabel(potential_client: PotentialClient): string {
    const company_name = potential_client.company_name?.trim() ?? '';
    const contact_name = potential_client.full_name?.trim() ?? '';

    if (company_name !== '' && contact_name !== '') {
      return `${company_name} (${contact_name})`;
    }

    return company_name || contact_name || 'Cliente potencial';
  }

  private loadExamEvaluationsForUser(user_id: number): void {
    this.api
      .getExamInstanceEvaluations({
        user_id,
        per_page: 500,
        order_by: 'created_at:desc',
        with: 'exam_instance',
      })
      .subscribe(response => {
        this.exam_instance_evaluations = Array.isArray(response) ? response : response.data;
      });
  }

  private mergeExamInstanceEvaluation(exam_instance_evaluation: ExamInstanceEvaluation): void {
    const evaluation_already_loaded = this.exam_instance_evaluations.some(evaluation => evaluation.id === exam_instance_evaluation.id);

    if (!evaluation_already_loaded) {
      this.exam_instance_evaluations = [exam_instance_evaluation, ...this.exam_instance_evaluations];
    }
  }

  private create_evaluation_for_meeting_user(exam_instance_id: number): void {
    const evaluation_user_id = this.evaluation_user_id;

    if (evaluation_user_id == null) {
      this.snack_bar.open('No hay usuario vinculado para iniciar la evaluación.', undefined, {
        duration: 5000,
      });
      return;
    }

    this.api
      .createExamInstanceEvaluation({
        user_id: evaluation_user_id,
        exam_instance_id,
      })
      .pipe(
        switchMap((evaluation: ExamInstanceEvaluation) => {
          this.linked_exam_instance_evaluation = evaluation;
          this.exam_instance_evaluations = [evaluation, ...this.exam_instance_evaluations];
          this.meetingRecordFormGroup.controls['exam_instance_evaluation_id'].patchValue(evaluation.id);

          return this.linkExamEvaluationToMeetingRecord(evaluation.id).pipe(
            map(meeting_record => ({ evaluation, meeting_record, link_failed: false })),
            catchError(() => of({ evaluation, meeting_record: null, link_failed: true }))
          );
        })
      )
      .subscribe({
        next: ({ evaluation, meeting_record, link_failed }): void => {
          if (link_failed) {
            this.snack_bar.open('Evaluación creada, pero no se pudo vincular al acta.', undefined, {
              duration: 5000,
            });
          } else if (meeting_record !== null) {
            this.applyPersistedMeetingRecord(meeting_record);
            this.snack_bar.open('Evaluación vinculada al acta.', undefined, { duration: 3000 });
          } else if (this.is_create) {
            this.snack_bar.open(
              'Evaluación creada. Completa título y asistentes del acta para vincularla automáticamente, o guárdala manualmente.',
              undefined,
              { duration: 6000 }
            );
          }

          this.navigateToExamEvaluationDetail(evaluation, meeting_record?.id ?? null);
        },
        error: (): void => {
          this.snack_bar.open('No se pudo iniciar la evaluación.', undefined, { duration: 5000 });
        },
      });
  }

  private listenPersonalNotesChanges(): void {
    this.personal_notes_control.valueChanges
      .pipe(
        debounceTime(800),
        distinctUntilChanged(),
        filter(() => !this.is_create && this.meetingRecordId > 0),
        switchMap(personal_notes => {
          const normalized_personal_notes = this.isPersonalNotesHtmlEmpty(personal_notes) ? null : personal_notes;

          return this.api.updateMeetingRecordPersonalNotes(this.meetingRecordId, normalized_personal_notes);
        }),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe({
        error: (): void => {
          this.snack_bar.open('No se pudieron guardar las notas personales.', undefined, { duration: 4000 });
        },
      });
  }

  private listenMeetingRecordFormAutosave(): void {
    this.meetingRecordFormGroup.valueChanges
      .pipe(
        tap(() => {
          this.form_change_generation += 1;
          if (this.autosave_status() === PendingChangesSaveStatus.Saved) {
            this.pending_changes_save_status.hideSavedMessage();
          }

          const can_mark_pending =
            this.meetingRecordFormGroup.dirty &&
            this.meetingRecordFormGroup.valid &&
            this.autosave_status() !== PendingChangesSaveStatus.Saving;

          if (can_mark_pending) {
            this.pending_changes_save_status.markPending();
          }
        }),
        debounceTime(5000),
        filter(() => this.meetingRecordFormGroup.valid && this.meetingRecordFormGroup.dirty),
        concatMap(() => this.persistMeetingRecord(false)),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe();
  }

  private persistMeetingRecord(force: boolean): Observable<MeetingRecord | null> {
    if (!this.meetingRecordFormGroup.valid) {
      return of(null);
    }

    if (!force && !this.meetingRecordFormGroup.dirty) {
      return of(null);
    }

    if (this.is_persisting) {
      return of(null);
    }

    const generation_at_start = this.form_change_generation;
    const was_create = this.is_create;
    this.is_persisting = true;
    this.pending_changes_save_status.markSaving();

    const form = this.buildMeetingRecordSubmitPayload();
    const request$ = was_create
      ? this.api.createMeetingRecord(form, { silent: true })
      : force
        ? this.persistPersonalNotesNow().pipe(
            switchMap(() => this.api.updateMeetingRecord(this.meetingRecordId.toString(), form, { silent: true }))
          )
        : this.api.updateMeetingRecord(this.meetingRecordId.toString(), form, { silent: true });

    return request$.pipe(
      tap(data => {
        this.onMeetingRecordPersistSuccess(data, was_create, generation_at_start);
      }),
      catchError(() => {
        this.pending_changes_save_status.markError();
        return of(null);
      }),
      finalize(() => {
        this.is_persisting = false;
      })
    );
  }

  private onMeetingRecordPersistSuccess(data: MeetingRecord, was_create: boolean, generation_at_start: number): void {
    this.syncSavedMeetingRecordDate(data.date);
    void this.linkActiveRecordingToMeetingRecord(data.id);
    this.last_saved_at.set(new Date());

    if (was_create) {
      this.is_create = false;
      this.meetingRecordId = data.id;
      this.can_manage_attachments.set(true);
      this.attachments.set(data.attachments ?? []);
      this.meetingRecordFormGroup.patchValue({ id: data.id }, { emitEvent: false });
    }

    if (generation_at_start === this.form_change_generation) {
      this.meetingRecordFormGroup.markAsPristine();
      this.pending_changes_save_status.markSaved();
    } else {
      this.pending_changes_save_status.markPending();
    }

    if (was_create) {
      this.isSubmitting = true;
      this.navigateAfterMeetingRecordCreate(data.id);
    }
  }

  private navigateAfterMeetingRecordCreate(meeting_record_id: number): void {
    if (this.onSaveRoute) {
      this.router.navigate([this.onSaveRoute.replace(':meeting_record_id', meeting_record_id.toString())], {
        queryParams: this.activatedRoute.snapshot.queryParams,
      });
      return;
    }

    this.router.navigate([meeting_record_id], {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'preserve',
    });
  }

  private isPersonalNotesHtmlEmpty(personal_notes_html: string): boolean {
    return this.isMeetingRecordHtmlEmpty(personal_notes_html);
  }

  private isMeetingRecordHtmlEmpty(html: string | null | undefined): boolean {
    const plain_text = (html ?? '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .trim();

    return plain_text === '';
  }

  private resolveInitialActaTab(meeting_record: MeetingRecord): MeetingRecordActaTabId {
    if (!this.isMeetingRecordHtmlEmpty(meeting_record.content)) {
      return 'acta';
    }

    if (!this.isMeetingRecordHtmlEmpty(meeting_record.ai_summary_html)) {
      return 'ai_summary';
    }

    return 'acta';
  }

  private refetchMeetingRecordStateAfterMediaRecordingChange(): void {
    if (!this.meetingRecordId) {
      return;
    }

    const was_summary_generation_processing = this.summary_generation_status() === 'processing';

    forkJoin({
      meeting_record: this.api.getMeetingRecord(this.meetingRecordId.toString(), {
        with: this.buildMeetingRecordFetchWithParam(),
      }),
      media_recordings: this.api.getMeetingRecordMediaRecordings(this.meetingRecordId),
    }).subscribe(({ meeting_record, media_recordings }) => {
      this.summary_generation_status.set(meeting_record.summary_generation_status ?? null);

      const ai_summary_html = (meeting_record.ai_summary_html ?? '').trim();

      if (ai_summary_html !== '') {
        this.ai_summary_html.set(meeting_record.ai_summary_html ?? null);
      }

      this.media_recordings.set(media_recordings);

      const summary_completed =
        was_summary_generation_processing && (meeting_record.summary_generation_status ?? null) === null && ai_summary_html !== '';

      if (summary_completed) {
        this.snack_bar.open('Resumen generado correctamente.', 'Cerrar', { duration: 4000 });
      }

      this.syncMeetingRecordRealtimeUpdates();
      this.change_detector_ref.markForCheck();
    });
  }

  private refetchMeetingRecordSummaryFromApi(was_summary_generation_processing = false): void {
    if (!this.meetingRecordId) {
      return;
    }

    this.api.getMeetingRecord(this.meetingRecordId.toString(), { with: this.buildMeetingRecordFetchWithParam() }).subscribe(data => {
      this.summary_generation_status.set(data.summary_generation_status ?? null);

      const ai_summary_html = (data.ai_summary_html ?? '').trim();

      if (ai_summary_html !== '') {
        this.ai_summary_html.set(data.ai_summary_html ?? null);
      }

      const summary_completed =
        was_summary_generation_processing && (data.summary_generation_status ?? null) === null && ai_summary_html !== '';

      if (summary_completed) {
        this.snack_bar.open('Resumen generado correctamente.', 'Cerrar', { duration: 4000 });
      }

      this.syncMeetingRecordRealtimeUpdates();
      this.change_detector_ref.markForCheck();
    });
  }

  private async importMediaRecordingAudio(file: File): Promise<void> {
    if (!this.meetingRecordId) {
      return;
    }

    if (!this.assertCanAddMeetingRecording()) {
      return;
    }

    this.is_importing_media_recording = true;
    this.change_detector_ref.markForCheck();

    try {
      const media_recording = await firstValueFrom(
        this.api.createMediaRecording({
          concept: this.buildImportedMediaRecordingConcept(file.name),
          client_local_id: crypto.randomUUID(),
          media_type: 'audio',
          capture_mode: 'microphone',
          recordable_type: 'App\\Models\\MeetingRecord',
          recordable_id: this.meetingRecordId,
        })
      );

      const server_id = media_recording.id;
      const slices = this.recording_service.splitBlobForServerUpload(file);

      for (let i = 0; i < slices.length; i++) {
        await firstValueFrom(this.api.uploadMediaRecordingChunk(server_id, i, slices[i], undefined, { segment_index: 0, part_index: i }));
      }

      await firstValueFrom(
        this.api.stopMediaRecording(server_id, {
          expected_chunk_count: slices.length,
        })
      );
      await firstValueFrom(this.api.finalizeMediaRecordingUpload(server_id));

      this.snack_bar.open('Audio importado. El procesamiento se está ejecutando.', undefined, { duration: 5000 });
      this.fetchMediaRecordings();
    } catch {
      this.snack_bar.open('No se pudo importar el audio.', undefined, { duration: 5000 });
    } finally {
      this.is_importing_media_recording = false;
      this.change_detector_ref.markForCheck();
    }
  }

  private async importMediaRecordingFromYoutube(youtube_url: string): Promise<void> {
    if (!this.meetingRecordId) {
      return;
    }

    if (!this.assertCanAddMeetingRecording()) {
      return;
    }

    this.is_importing_media_recording = true;
    this.change_detector_ref.markForCheck();

    try {
      await firstValueFrom(
        this.api.importMediaRecordingFromYoutube({
          concept: this.buildImportedMediaRecordingConcept('Grabación de YouTube'),
          client_local_id: crypto.randomUUID(),
          youtube_url,
          recordable_type: 'App\\Models\\MeetingRecord',
          recordable_id: this.meetingRecordId,
        })
      );
      this.snack_bar.open('Vídeo de YouTube importado. El procesamiento se está ejecutando.', undefined, {
        duration: 5000,
      });
      this.fetchMediaRecordings();
    } catch {
      this.snack_bar.open('No se pudo importar el vídeo de YouTube.', undefined, { duration: 5000 });
    } finally {
      this.is_importing_media_recording = false;
      this.change_detector_ref.markForCheck();
    }
  }

  private buildImportedMediaRecordingConcept(fallback_label: string): string {
    const meeting_title = ((this.meetingRecordFormGroup.value.title as string) ?? '').trim();

    if (meeting_title !== '') {
      return meeting_title;
    }

    return fallback_label.replace(/\.[^.]+$/, '') || 'Grabación importada';
  }

  private buildMeetingRecordSubmitPayload(): Record<string, unknown> {
    const form: Record<string, unknown> = { ...this.meetingRecordFormGroup.value };

    form['assistants_ids'] = ((form['users'] as User[]) ?? []).map(user => user.id);
    delete form['users'];

    return form;
  }

  private canPersistMeetingRecordForExamLink(): boolean {
    const form_value = this.meetingRecordFormGroup.getRawValue();
    const users = form_value['users'] as User[];
    const title = ((form_value['title'] as string) ?? '').trim();

    return (
      Boolean(form_value['meetingable_id']) &&
      Boolean(form_value['meetingable_type']) &&
      Boolean(form_value['date']) &&
      title.length >= 5 &&
      users.length >= 1
    );
  }

  private linkExamEvaluationToMeetingRecord(exam_instance_evaluation_id: number): Observable<MeetingRecord | null> {
    if (!this.is_create && this.meetingRecordId) {
      return this.api.updateMeetingRecord(this.meetingRecordId.toString(), {
        exam_instance_evaluation_id,
      });
    }

    if (!this.canPersistMeetingRecordForExamLink()) {
      return of(null);
    }

    const payload = this.buildMeetingRecordSubmitPayload();
    payload['exam_instance_evaluation_id'] = exam_instance_evaluation_id;

    return this.api.createMeetingRecord(payload);
  }

  private applyPersistedMeetingRecord(meeting_record: MeetingRecord): void {
    this.is_create = false;
    this.meetingRecordId = meeting_record.id;
    this.can_manage_attachments.set(true);
    this.attachments.set(meeting_record.attachments ?? []);
    this.meetingRecordFormGroup.patchValue({ id: meeting_record.id });
    this.meetingRecordFormGroup.markAsPristine();
    this.last_saved_at.set(meeting_record.updated_at ? new Date(meeting_record.updated_at) : new Date());
    this.pending_changes_save_status.reset();
  }

  private resolveBackRoute(from: string | null): string {
    if (from === 'assisted-meeting-records') {
      return '/employees/activity/assisted-meeting-records';
    }

    if (this.onBackRoute) {
      return this.onBackRoute;
    }

    return this.is_create ? '..' : '../..';
  }

  private getMeetingRecordReturnUrl(meeting_record_id: number | null = null): string {
    const resolved_meeting_record_id = meeting_record_id ?? (this.is_create ? null : this.meetingRecordId);

    if (this.onSaveRoute && resolved_meeting_record_id) {
      return this.onSaveRoute.replace(':meeting_record_id', resolved_meeting_record_id.toString());
    }

    const current_url = this.router.url.split('?')[0];

    if (resolved_meeting_record_id == null) {
      return current_url;
    }

    if (current_url.endsWith('/new')) {
      return current_url.replace('/new', `/${resolved_meeting_record_id}`);
    }

    if (current_url.endsWith('/create')) {
      return current_url.replace('/create', `/${resolved_meeting_record_id}`);
    }

    return current_url;
  }

  private navigateToExamEvaluationDetail(evaluation: ExamInstanceEvaluation, meeting_record_id: number | null = null): void {
    void this.router.navigate(['/employees', 'rrhh', 'exam-instances', evaluation.exam_instance_id, 'evaluations', evaluation.id], {
      queryParams: {
        meeting_record_return_url: this.getMeetingRecordReturnUrl(meeting_record_id),
      },
    });
  }

  private isMeetingRecordRecordingAllowed(meeting_date: Date | string | null | undefined): boolean {
    if (meeting_date === null || meeting_date === undefined || meeting_date === '') {
      return false;
    }

    const meeting_day_start = dayjs(meeting_date).tz('Europe/Madrid').startOf('day');
    const recording_deadline = meeting_day_start.add(1, 'day');

    return dayjs().tz('Europe/Madrid').isBefore(recording_deadline);
  }
}

export function canRetryMediaRecordingTranscription(recording: MediaRecording): boolean {
  if (recording.recording_status !== 'completed' || recording.transcription_status !== 'failed') {
    return false;
  }

  const has_local_file = recording.storage_path !== null && recording.storage_path !== '';
  const has_youtube_video =
    recording.youtube_video_id !== null && recording.youtube_video_id !== '' && recording.youtube_upload_status === 'completed';

  return has_local_file || has_youtube_video;
}

export function buildYoutubeEmbedUrl(youtube_video_id: string): string {
  const params = new URLSearchParams();

  if (typeof window !== 'undefined' && window.location.origin !== '') {
    params.set('origin', window.location.origin);
  }

  const query_string = params.toString();

  return query_string === ''
    ? `https://www.youtube.com/embed/${encodeURIComponent(youtube_video_id)}`
    : `https://www.youtube.com/embed/${encodeURIComponent(youtube_video_id)}?${query_string}`;
}

export function isMediaRecordingLinkedToMeetingRecord(
  recordable_type: string | null | undefined,
  recordable_id: number | null | undefined
): recordable_id is number {
  if (recordable_id == null) {
    return false;
  }

  return recordable_type === 'App\\Models\\MeetingRecord' || recordable_type === 'MeetingRecord';
}

export function buildMeetingRecordDetailRoute(meeting_record: MeetingRecord): string[] | null {
  switch (meeting_record.meetingable_type) {
    case 'App\\Models\\CompanyProduct':
      return [
        '/employees',
        'development',
        'company-products',
        String(meeting_record.meetingable_id),
        'meeting-records',
        String(meeting_record.id),
      ];
    case 'App\\Models\\User':
      return ['/employees', 'direction', 'users', String(meeting_record.meetingable_id), 'meeting-records', String(meeting_record.id)];
    case 'App\\Models\\PotentialClient':
      return [
        '/employees',
        'comercial',
        'potential-clients',
        String(meeting_record.meetingable_id),
        'meeting-records',
        String(meeting_record.id),
      ];
    case 'App\\Models\\JobVacancyCandidatePhaseProgress': {
      const phase_progress = meeting_record.meetingable as JobVacancyCandidatePhaseProgress | undefined;
      const job_vacancy_candidate = (phase_progress as { job_vacancy_candidate?: { id: number; job_vacancy_id: number } })
        ?.job_vacancy_candidate;

      if (!job_vacancy_candidate) {
        return null;
      }

      return [
        '/employees',
        'rrhh',
        'job-vacancies',
        String(job_vacancy_candidate.job_vacancy_id),
        'candidates',
        String(job_vacancy_candidate.id),
        'meeting-records',
        String(meeting_record.id),
      ];
    }
    default:
      return null;
  }
}

export interface MediaRecordingUploadRetryContext {
  can_retry: boolean;
  kind: MediaRecordingUploadRetryKindEnum | null;
  failure_phase: MediaRecordingUploadFailurePhaseEnum;
  failure_summary: string;
  retry_summary: string | null;
  button_label: string;
}

interface MeetingRecordRecordingCardView {
  active_recording: ActiveRecordingState | null;
  block_message: string | null;
  show_live_panel: boolean;
  show_upload_panel: boolean;
  show_blocked_panel: boolean;
  show_deadline_blocked_panel: boolean;
  show_idle_panel: boolean;
}

export { MediaRecordingUploadFailurePhaseEnum } from 'src/app/enums/media-recording-upload-failure-phase.enum';
export { MediaRecordingUploadRetryKindEnum } from 'src/app/enums/media-recording-upload-retry-kind.enum';

const RETRIABLE_MEDIA_RECORDING_UPLOAD_STATUSES: MediaRecording['recording_status'][] = [
  'pending_upload',
  'upload_failed',
  'failed',
  'stopped',
];

export function areMediaRecordingChunksCompleteOnServer(recording: MediaRecording): boolean {
  const expected_chunk_count = recording.expected_chunk_count;
  const received_chunk_count = recording.received_chunk_count ?? 0;

  if (expected_chunk_count !== null && expected_chunk_count > 0) {
    return received_chunk_count >= expected_chunk_count;
  }

  return received_chunk_count > 0;
}

function formatMediaRecordingChunkProgress(recording: MediaRecording): string {
  const expected_chunk_count = recording.expected_chunk_count;
  const received_chunk_count = recording.received_chunk_count ?? 0;

  if (expected_chunk_count !== null && expected_chunk_count > 0) {
    return `${received_chunk_count} de ${expected_chunk_count} fragmentos en el servidor`;
  }

  return `${received_chunk_count} fragmentos en el servidor`;
}

export function resolveMediaRecordingUploadRetryContext(
  recording: MediaRecording,
  has_local_retry_data: boolean
): MediaRecordingUploadRetryContext | null {
  const chunks_complete_on_server = areMediaRecordingChunksCompleteOnServer(recording);
  const chunk_progress_label = formatMediaRecordingChunkProgress(recording);
  const should_retry_chunk_upload = has_local_retry_data && !chunks_complete_on_server;

  const is_retriable_status =
    RETRIABLE_MEDIA_RECORDING_UPLOAD_STATUSES.includes(recording.recording_status) ||
    (recording.recording_status === 'uploading' && should_retry_chunk_upload) ||
    (recording.recording_status === 'uploading' && chunks_complete_on_server);

  if (!is_retriable_status) {
    return null;
  }

  if (!has_local_retry_data && !chunks_complete_on_server) {
    return {
      can_retry: false,
      kind: null,
      failure_phase: MediaRecordingUploadFailurePhaseEnum.Unavailable,
      failure_summary: `Subida incompleta (${chunk_progress_label}) y no hay copia local en este navegador.`,
      retry_summary: null,
      button_label: 'Reintentar',
    };
  }

  if (should_retry_chunk_upload) {
    let failure_summary = `Falló la subida de fragmentos al servidor (${chunk_progress_label}).`;

    if (recording.recording_status === 'pending_upload') {
      failure_summary = `Subida de fragmentos pendiente (${chunk_progress_label}).`;
    } else if (recording.recording_status === 'uploading') {
      failure_summary = `Subida de fragmentos interrumpida (${chunk_progress_label}).`;
    }

    return {
      can_retry: true,
      kind: MediaRecordingUploadRetryKindEnum.ChunkUpload,
      failure_phase: MediaRecordingUploadFailurePhaseEnum.ChunkUpload,
      failure_summary,
      retry_summary:
        'Se volverán a subir los fragmentos desde este navegador y, al completarse, continuará el procesamiento en el servidor.',
      button_label: 'Reintentar subida de fragmentos',
    };
  }

  if (recording.recording_status === 'uploading' && chunks_complete_on_server) {
    return {
      can_retry: true,
      kind: MediaRecordingUploadRetryKindEnum.ServerProcessing,
      failure_phase: MediaRecordingUploadFailurePhaseEnum.ServerProcessing,
      failure_summary: `Todos los fragmentos están en el servidor (${chunk_progress_label}). Falta iniciar el procesamiento.`,
      retry_summary: 'Se iniciará la unión del vídeo y el procesamiento en el servidor. No hace falta volver a grabar.',
      button_label: 'Continuar procesamiento',
    };
  }

  if (recording.recording_status === 'stopped' && chunks_complete_on_server) {
    return {
      can_retry: true,
      kind: MediaRecordingUploadRetryKindEnum.ServerProcessing,
      failure_phase: MediaRecordingUploadFailurePhaseEnum.ServerProcessing,
      failure_summary: `Todos los fragmentos están en el servidor (${chunk_progress_label}). Falta iniciar el procesamiento.`,
      retry_summary: 'Se iniciará la unión del vídeo y el procesamiento en el servidor. No hace falta volver a grabar.',
      button_label: 'Continuar procesamiento',
    };
  }

  const is_youtube_upload_failure = recording.media_type === 'video' && recording.youtube_upload_status === 'failed';

  let failure_phase = MediaRecordingUploadFailurePhaseEnum.ServerProcessing;
  let failure_summary = `Falló el procesamiento en el servidor (${chunk_progress_label}).`;

  if (recording.recording_status === 'stopped') {
    failure_summary = `La grabación se detuvo antes de finalizar (${chunk_progress_label}).`;
  } else if (recording.recording_status === 'pending_upload') {
    failure_summary = `Grabación pendiente de procesar en el servidor (${chunk_progress_label}).`;
  } else if (is_youtube_upload_failure) {
    failure_phase = MediaRecordingUploadFailurePhaseEnum.YoutubeUpload;
    failure_summary = `Falló la subida del vídeo a YouTube (${chunk_progress_label}).`;
  } else if (recording.recording_status === 'failed') {
    failure_summary = `El procesamiento de la grabación falló (${chunk_progress_label}).`;
  }

  let button_label = 'Reintentar procesamiento';
  let retry_summary = 'Se reintentará la unión y el almacenamiento en el servidor. No hace falta volver a grabar.';

  if (is_youtube_upload_failure) {
    button_label = 'Reintentar subida a YouTube';
    retry_summary = 'Se reintentará la subida a YouTube en el servidor. No hace falta volver a grabar.';
  } else if (recording.media_type === 'video') {
    button_label = 'Reintentar procesamiento en el servidor';
    retry_summary = 'Se reintentará la unión y conversión del vídeo en el servidor. No hace falta volver a grabar.';
  }

  return {
    can_retry: true,
    kind: MediaRecordingUploadRetryKindEnum.ServerProcessing,
    failure_phase,
    failure_summary,
    retry_summary,
    button_label,
  };
}

export function hasMeetingRecordMediaRecordingsInProgress(recordings: MediaRecording[]): boolean {
  const transcription_in_flight_pipe = new MediaRecordingTranscriptionInFlightPipe();
  const processing_on_server_pipe = new MediaRecordingProcessingOnServerPipe();

  return recordings.some(recording => transcription_in_flight_pipe.transform(recording) || processing_on_server_pipe.transform(recording));
}

export function getMeetingRecordPusherChannelName(meeting_record_id: number): string {
  return `private-meeting-record.${meeting_record_id}`;
}

export function applyMeetingRecordMediaRecordingPusherUpdate(
  recordings: MediaRecording[],
  update: MeetingRecordMediaRecordingPusherUpdate
): MediaRecording[] {
  const recording_index = recordings.findIndex(recording => recording.id === update.media_recording_id);

  if (recording_index === -1) {
    return recordings;
  }

  const updated_recordings = [...recordings];
  const current_recording = updated_recordings[recording_index];

  updated_recordings[recording_index] = {
    ...current_recording,
    recording_status: update.recording_status,
    server_processing_status: update.server_processing_status,
    transcription_status: update.transcription_status,
    transcription_error: update.transcription_error,
    youtube_upload_status: update.youtube_upload_status as MediaRecording['youtube_upload_status'],
  };

  return updated_recordings;
}
